import {Scope} from '../constants/scopes';

export class AuthContext {
  apis: string;
  clientId: string;
  scope: Scope[];
  additionalScopes: Scope[];
}
